import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Plus, Trash, FileText } from '@phosphor-icons/react';
import { API } from './adminConstants';

export function DocumentManagement() {
  const { getAuthHeader } = useAuth();
  const [docs, setDocs] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ title: '', description: '', category: 'policy', file_base64: '', filename: '' });

  const load = async () => { const r = await axios.get(`${API}/documents`, { headers: getAuthHeader() }); setDocs(r.data); };
  useEffect(() => { load(); }, []);

  const handleFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => setForm(prev => ({ ...prev, file_base64: reader.result.split(',')[1], filename: file.name }));
    reader.readAsDataURL(file);
  };

  const handleUpload = async () => {
    if (!form.title || !form.file_base64) { toast.error('Title and file required'); return; }
    try {
      await axios.post(`${API}/admin/documents`, form, { headers: getAuthHeader() });
      toast.success('Document uploaded');
      setShowForm(false); setForm({ title: '', description: '', category: 'policy', file_base64: '', filename: '' });
      load();
    } catch { toast.error('Failed'); }
  };

  const handleDelete = async (id) => {
    try { await axios.delete(`${API}/admin/documents/${id}`, { headers: getAuthHeader() }); toast.success('Deleted'); load(); } catch { toast.error('Failed'); }
  };

  return (
    <div data-testid="document-management">
      <div className="flex items-center justify-between mb-6">
        <div><h1 className="font-outfit font-bold text-2xl text-slate-900">HR Documents</h1></div>
        <Button onClick={() => setShowForm(!showForm)} className="bg-lime-600 hover:bg-lime-700"><Plus size={15} className="mr-1" />Upload Document</Button>
      </div>
      {showForm && (
        <div className="mb-4 bg-white rounded-xl border border-slate-200 p-6 space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <div><Label className="text-xs">Title</Label><Input value={form.title} onChange={e => setForm({...form, title: e.target.value})} data-testid="doc-title" /></div>
            <div><Label className="text-xs">Category</Label>
              <Select value={form.category} onValueChange={v => setForm({...form, category: v})}><SelectTrigger><SelectValue /></SelectTrigger><SelectContent><SelectItem value="policy">Policy</SelectItem><SelectItem value="form">Form</SelectItem><SelectItem value="handbook">Handbook</SelectItem><SelectItem value="other">Other</SelectItem></SelectContent></Select>
            </div>
          </div>
          <div><Label className="text-xs">Description</Label><Textarea value={form.description} onChange={e => setForm({...form, description: e.target.value})} rows={2} /></div>
          <div><Label className="text-xs">File</Label><Input type="file" onChange={handleFile} data-testid="doc-file" /></div>
          {form.filename && <p className="text-xs text-slate-500">Selected: {form.filename}</p>}
          <div className="flex gap-3"><Button variant="outline" onClick={() => setShowForm(false)}>Cancel</Button><Button onClick={handleUpload} className="bg-lime-600 hover:bg-lime-700" data-testid="upload-doc">Upload</Button></div>
        </div>
      )}
      <div className="bg-white rounded-xl border border-slate-200 divide-y divide-slate-100">
        {docs.map(d => (
          <div key={d.id} className="p-4 flex items-center justify-between">
            <div className="flex items-center gap-3"><FileText size={20} className="text-slate-400" /><div><p className="font-medium text-sm text-slate-900">{d.title}</p><p className="text-xs text-slate-500">{d.category} | {d.filename}</p></div></div>
            <Button variant="ghost" size="sm" onClick={() => handleDelete(d.id)} className="text-red-500"><Trash size={14} /></Button>
          </div>
        ))}
        {docs.length === 0 && <div className="p-8 text-center text-slate-500">No documents</div>}
      </div>
    </div>
  );
}
